/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

import { CIColors } from 'shared';

export const createMembersListStyles = makeStyles(theme => ({
  root: {
    marginBottom: '14px',
    width: '100%',
    maxWidth: '800px',
  },
  firstTableCell: {
    width: '42%',
  },
  you: {
    color: theme.palette.tertiary.main,
    paddingLeft: '10px',
  },
  deleteIcon: {
    margin: '0 0 0 8px',
    color: theme.palette.graphicElements.main,
    width: '24px',
    height: '24px',
    padding: '0',
    '&:hover': {
      color: CIColors.GraphicElementsHover,
    },
  },
  formSelectWrapper: {
    marginLeft: '-10px',
    maxWidth: '90px',
    '&:hover': {
      '& > $formSelect': {
        borderColor: '#EEEEEE',
        color: '#41404A',
      },
      '& > $formIcon': {
        opacity: 1,
      },
    },
  },
  formSelect: {
    padding: '5px 10px',
    borderColor: 'transparent',
    '&:focus': {
      borderColor: 'transparent',
      boxShadow: 'none',
      backgroundColor: 'transparent',
    },
  },
  formIcon: {
    fontSize: '24px',
  },
}));
